import { render, staticRenderFns } from "./CustomDataView.vue?vue&type=template&id=03c13624"
import script from "./CustomDataView.vue?vue&type=script&lang=ts"
export * from "./CustomDataView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports